import { getGtpItemsFromRow } from '@/utils/formatGtpList';

export const OPEN_GTP_ROW_DETAIL_FOR_GENE_EVENT = 'disgenet:open-bottom-row-detail-for-gene';

const FALLBACK_LABELS: Record<string, string> = {
  symbol: 'Gene',
  ncbiID: 'Gene NCBI Id',
  description: 'Gene Full Name',
  DPI: 'DPI',
  DSI: 'DSI',
  PLI: 'pLI',
  GTP: 'GTP',
};

function toGeneId(value: unknown): string {
  if (value == null) return '';
  return String(value).trim();
}

export function getGeneIdCandidates(row: Record<string, unknown> | null | undefined): string[] {
  if (!row) return [];
  const candidates = [row.ncbiID, row.geneNcbiID, row.gene_ncbi_id, row.gene_ncbi, row.geneID, row.geneId];
  if (Array.isArray(row.geneNcbiIDs)) {
    candidates.push(...row.geneNcbiIDs);
  }
  return candidates.map(toGeneId).filter(id => id && id !== '-' && id !== '0');
}

export function rowMatchesGeneId(row: Record<string, unknown> | null | undefined, geneId: string): boolean {
  const needle = toGeneId(geneId);
  if (!needle || needle === '-') return false;
  return getGeneIdCandidates(row).some(id => id === needle);
}

export function buildGtpRowDetailFallback(geneDetailInfo: Record<string, unknown>) {
  const original: Record<string, unknown> = {
    symbol: geneDetailInfo.symbol,
    ncbiID: geneDetailInfo.ncbiID ?? geneDetailInfo.geneID ?? geneDetailInfo.gene_ncbi,
    description: geneDetailInfo.description,
    DPI: geneDetailInfo.DPI,
    DSI: geneDetailInfo.DSI,
    PLI: geneDetailInfo.PLI,
    GTP: geneDetailInfo.GTP ?? geneDetailInfo.gtp,
  };

  return {
    original,
    values: original,
    labels: FALLBACK_LABELS,
    categories: {
      symbol: 'Gene',
      ncbiID: 'Gene',
      description: 'Gene',
      DPI: 'Gene',
      DSI: 'Gene',
      PLI: 'Gene',
      GTP: 'Gene',
    },
  };
}

export function dispatchOpenGtpRowDetailForGene(geneDetailInfo: Record<string, unknown>) {
  const geneId = toGeneId(
    geneDetailInfo.ncbiID ?? geneDetailInfo.geneID ?? geneDetailInfo.gene_ncbi ?? geneDetailInfo.geneId,
  );
  const event = new CustomEvent(OPEN_GTP_ROW_DETAIL_FOR_GENE_EVENT, {
    detail: { geneId },
    cancelable: true,
  });
  window.dispatchEvent(event);
  if (event.defaultPrevented) return;
  if (getGtpItemsFromRow(geneDetailInfo).length === 0) return;
  window.dispatchEvent(
    new CustomEvent('disgenet:open-bottom-row-detail', {
      detail: buildGtpRowDetailFallback(geneDetailInfo),
    }),
  );
}
